<template>
  <div class="exe-container">
    <div class="exe-container__title">
      <div>{{ $t('label.execution') + ' ' + this.$util.capitalize($t('label.history1')) }}</div>
      <lego-icon @click="close">close</lego-icon>
    </div>
    <div class="exe-container__table">
      <lego-paging-table
        tableFixed
        noPage
        isNotScrollX
        v-model="selected"
        :items="items"
        :headers="headers"
        :noDataText="noDataText"
        singleSelect
        style="width: 100%"
        :selectActionControl="false"
        :scrollMaxRow="10"
      ></lego-paging-table>
    </div>

    <div class="exe-container__action">
      <lego-button @click="close">{{ $t('button.cancel') }}</lego-button>
      <lego-button
        style="margin-left: 16px"
        @click="apply"
        main
        :disabled="!this.selected.length"
        >{{ $t('button.confirm') }}</lego-button
      >
    </div>
  </div>
</template>
<script>
import tableMixins from '@/mixins/table.mixin.js';
import i18nMixin from '@/mixins/i18n.mixin.js';

import moment from 'moment';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();

export default {
  mixins: [tableMixins, i18nMixin],
  props: ['params'],
  emits: ['applyQuery', 'close'],
  created() {
    this.getData();
  },
  mounted() {},
  data() {
    return {
      items: [],
      headers: [
        {
          text: this.$t('label.lastRunDate'), // 최근실행일
          value: 'createdDt',
          width: 170,
          sortable: false,
          bodyAlign: 'center',
          customCell: (value) => {
            let time = formatDateTime(value, FULL_TIME_FORMAT);
            return `<div class="ellipsis" v-lego-tooltip:ellipsis="'${time}'">${time}</div>`;
          }
        },
        {
          text: this.$t('label.executionResult'), // 실행 결과
          value: 'queryResult',
          width: 120,
          sortable: false,
          bodyAlign: 'center'
        },
        {
          text: this.$t('label.queryContent'), // 쿼리 내용
          value: 'displayQuery',
          sortable: false,
          bodyAlign: 'left'
        }
      ],
      selected: []
    };
  },
  methods: {
    // 닫기/취소
    close() {
      this.$emit('close');
    },

    // 적용
    apply() {
      if (this.selected.length) {
        this.$emit('applyQuery', this.$util.deepCopy(this.selected[0]));
        this.$emit('close');
      }
    },

    // 실행 이력 조회
    async getData() {
      let productSq = this.params.selectedLog.map((l) => l.productSq);
      let param = {
        productTypeCode: this.params.productTypeCode,
        productSqs: productSq.filter((v, i) => productSq.indexOf(v) === i).join(',')
      };
      await this.$http.log
        .getQueryHistory(param, this.params.productTypeCode, true)
        .then((res) => {
          this.setTableInfo(res);
        })
        .catch((error) => this.handleAccessDenied(error));
    }
  }
};
</script>

<style lang="scss" scoped>
.exe-container {
  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    line-height: 20px;
    font-weight: 700;
    padding-bottom: 16px;
    border-bottom: 1px solid #e3e4e8;
  }
  &__table {
    margin-top: 8px;
  }
  &__action {
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }
}
</style>
